import { jsx as _jsx } from "react/jsx-runtime";
import Skeleton from '@shared/ui/Skeleton';
import styles from './DocumentsListSkeleton.module.scss';
export function DocumentsListSkeleton() {
    return (_jsx("div", { className: styles.container, children: Array.from({ length: 24 }).map((_, index) => (_jsx(Skeleton, { className: styles.skeleton }, index))) }));
}
